import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { companyBySlugQueryOptions } from '@/entities/company'
import { Breadcrumb, type Crumb } from '@/shared/ui/breadcrumb'
import { MEETING_TABS, MeetingPageView } from '../-ui/meeting-page'

// Встреча в контуре компании: и её собственная (без проекта), и встреча любого
// её проекта — из ленты компании открывается здесь.
const MeetingSearchSchema = z.object({
  tab: z.enum(MEETING_TABS).optional().catch(undefined),
})

export const Route = createFileRoute('/_app/companies/$company_/meetings/$meeting')({
  validateSearch: (search) => MeetingSearchSchema.parse(search),
  head: () => ({ meta: [{ title: 'Встреча · STIT Deal' }] }),
  component: CompanyMeetingPage,
})

function CompanyMeetingPage() {
  const { company, meeting: meetingId } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  const companyQ = useQuery(companyBySlugQueryOptions(company))
  const c = companyQ.data

  return (
    <MeetingPageView
      meetingId={meetingId}
      activeTab={tab ?? 'comments'}
      onTabChange={(value) => void navigate({ search: { tab: value } })}
      docLink={(docId) => ({
        to: '/companies/$company/documents/$doc',
        params: { company, doc: docId },
      })}
      onDeleted={() =>
        void navigate({
          to: '/companies/$company',
          params: { company },
          search: { tab: 'meetings' },
        })
      }
      renderBreadcrumb={(m) => (
        <Breadcrumb
          items={
            [
              { label: c?.name ?? company, to: '/companies/$company', params: { company } },
              {
                label: 'Встречи',
                to: '/companies/$company',
                params: { company },
                search: { tab: 'meetings' },
              },
              { label: m.title },
            ] satisfies Crumb[]
          }
        />
      )}
    />
  )
}
